import { formatDate } from 'app/utils';
import { Checkbox, Flex, Icons, Typography } from 'components';
import { useState } from 'react';
import styled from 'styled-components';
import { answerItem } from '../messageInbox/MessageInbox';

export interface MessageItemProps {
  uuid: string;
  title: string;
  text: string;
  sender: string;
  subjects: string;
  status: 0 | 1; //1=lida | 0=nao lida
  isDelete: boolean;
  isAchive: boolean;
  isResponded: boolean;
  date: string;
  answer?: answerItem | null;
  type: string; // all: Recebidas sent:Enviadas archives:Arquivadas deleted:Deletadas
}
interface messageCardProps {
  message: MessageItemProps;
  onClickCard: () => void;
  selected: boolean;
}

const IconReply = styled(Icons)`
  width: 20px;
  color: ${({ theme }) => theme.colors.gray_300};
`;

const Icon = styled(Icons)`
  width: 24px;
  color: ${({ theme }) => theme.colors.gray_300};
`;

const IconPrimary = styled(Icons)`
  width: 24px;
  color: ${({ theme }) => theme.colors.primary_400};
`;

const MessageCard = ({ message, onClickCard, selected }: messageCardProps) => {
  const [status, setStatus] = useState(message.status);

  const handleClick = () => {
    if (status === 0) {
      setStatus(1);
    }
    onClickCard();
  };

  return (
    <Flex
      bg={selected ? 'gray_100' : 'white'}
      width={400}
      justifyContent="space-around"
      pl={5}
      py={12}
      borderBottomStyle="solid"
      borderBottomWidth="2px"
      borderBottomColor="gray_100"
      onClick={() => handleClick()}
      style={{ cursor: 'default' }}
    >
      <Flex>
        <Checkbox
          color="gray_300"
          // checked={sanitizedClassEvolution?.length === Object.keys(selectedStudents).length}
          // onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          //   if (event.target.checked) {
          //     selectManyStudents(true);
          //   } else {
          //     selectManyStudents(false);
          //   }
          // }}
        />
      </Flex>
      <Flex flexDirection="column">
        <Flex alignItems="center" mb={2}>
          {status === 0 ? <Flex bg="primary_400" width={16} height={16} borderRadius="50%" mr={2} flexGrow={0} /> : null}
          <Typography color={status === 0 ? 'black' : 'grayMessage'} type="type2" fontWeight={600}>
            {message.sender}
          </Typography>
        </Flex>
        <Typography color="gray_500" mb={2}>
          {message.title}
        </Typography>
        <Typography type="type0" upper color={status === 0 ? 'primary_200' : 'gray_500'} fontWeight={700}>
          {message.subjects}
        </Typography>
      </Flex>
      <Flex flexDirection="column">
        <Typography type="type0" color={status === 0 ? 'primary_200' : 'gray_500'} ml={2} upper>
          {formatDate(message.date).format('DD MMM')}
        </Typography>

        <Flex justifyContent="flex-end" mt={2}>
          {message.isResponded ? <IconReply icon="reply" /> : null}
          {status === 0 ? <IconPrimary icon="chevronRight" /> : <Icon icon="chevronRight" />}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default MessageCard;
